import { render, staticRenderFns } from "./DeliverableCustomField.vue?vue&type=template&id=4140f316&"
import script from "./DeliverableCustomField.vue?vue&type=script&lang=js&"
export * from "./DeliverableCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports